// test1045
(1045 && 0);
